import React, { useState, useRef } from "react";

const FlowchartBuilder = () => {
  const gridRef = useRef(null);
  const trashRef = useRef(null);
  const [blocks, setBlocks] = useState([]);

  const blockTypes = [
    "StartEnd",
    "InputOutput",
    "Process",
    "Decision",
    "Annotation",
    "ArrowDown",
    "ArrowLeft",
    "ArrowRight",
  ];

  const toolbarStyle = {
    display: "flex",
    gap: 8,
    padding: 10,
    background: "#ccc",
  };

  const buttonStyle = {
    padding: "6px 10px",
    border: "none",
    borderRadius: 4,
    background: "#222",
    color: "#fff",
    cursor: "grab",
  };

  const gridStyle = {
    position: "relative",
    width: "100%",
    height: "calc(100vh - 100px)",
    background: "white",
    border: "2px solid #999",
    backgroundSize: "40px 40px",
    backgroundImage:
      "linear-gradient(to right, #ddd 1px, transparent 1px), linear-gradient(to bottom, #ddd 1px, transparent 1px)",
    overflow: "hidden",
  };

  const trashStyle = {
    position: "fixed",
    bottom: 20,
    left: 20,
    background: "#333",
    color: "white",
    fontSize: 24,
    padding: 15,
    borderRadius: "50%",
    cursor: "pointer",
    textAlign: "center",
    width: 60,
    height: 60,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  };

  const resetBtnStyle = {
    position: "fixed",
    bottom: 20,
    right: 20,
    background: "red",
    color: "white",
    padding: "10px 20px",
    borderRadius: 10,
    border: "none",
    cursor: "pointer",
  };

  const getBlockStyle = (type) => {
    const baseStyle = {
      position: "absolute",
      padding: 10,
      textAlign: "center",
      color: "white",
      borderRadius: 6,
      cursor: "move",
      userSelect: "none",
      minWidth: 100,
      minHeight: 40,
      outline: "none",
    };
    switch (type) {
      case "StartEnd":
        return { ...baseStyle, background: "green", borderRadius: "50px", color: "black" };
      case "Process":
        return { ...baseStyle, background: "blue", color: "black" };
      case "InputOutput":
        return { ...baseStyle, background: "yellow", color: "black", transform: "skewX(-20deg)" };
      case "Decision":
        return { ...baseStyle, background: "red", clipPath: "polygon(50% 0%, 100% 50%, 50% 100%, 0% 50%)", color: "black" };
      case "Annotation":
        return { ...baseStyle, background: "gray", color: "black" };
      case "ArrowDown":
      case "ArrowLeft":
      case "ArrowRight":
        return { ...baseStyle, cursor: "default" };
      default:
        return baseStyle;
    }
  };

  const addBlock = (type, x, y) => {
    const id = Date.now().toString();
    const isArrow = type.startsWith("Arrow");
    const newBlock = {
      id,
      type,
      x,
      y,
      text: isArrow ? "" : type,
      isEditing: false,
     width:
  type === "ArrowLeft" || type === "ArrowRight"
    ? 100
    : isArrow
    ? 60
    : 120,

height:
  type === "ArrowLeft" || type === "ArrowRight"
    ? 100
    : isArrow
    ? 60
    : 50,

    };
    setBlocks((prev) => [...prev, newBlock]);
  };


  const handleDragStartToolbar = (e, type) => {
    e.dataTransfer.setData("blockType", type);
  };

  const handleDropGrid = (e) => {
    e.preventDefault();
    const type = e.dataTransfer.getData("blockType");
    if (!type) return;
    const rect = gridRef.current.getBoundingClientRect();
    const x = e.clientX - rect.left;
    const y = e.clientY - rect.top;
    addBlock(type, x, y);
  };

  const handleDragOverGrid = (e) => e.preventDefault();

  const handleMouseDown = (e, block) => {
    if (block.isEditing) return; // prevent drag during typing

    e.preventDefault();
    const rect = gridRef.current.getBoundingClientRect();
    const shiftX = e.clientX - (rect.left + block.x);
    const shiftY = e.clientY - (rect.top + block.y);

    const moveAt = (pageX, pageY) => {
      const newX = pageX - rect.left - shiftX;
      const newY = pageY - rect.top - shiftY;
      setBlocks((prev) =>
        prev.map((b) => (b.id === block.id ? { ...b, x: newX, y: newY } : b))
      );
    };

    const onMouseMove = (ev) => moveAt(ev.pageX, ev.pageY);
    document.addEventListener("mousemove", onMouseMove);
    document.addEventListener(
      "mouseup",
      () => document.removeEventListener("mousemove", onMouseMove),
      { once: true }
    );
  };
  const handleResizeMouseDown = (e, block) => {
    e.stopPropagation();
    const startX = e.clientX;
    const startY = e.clientY;
    const startWidth = block.width || 60;
    const startHeight = block.height || 60;

    const onMouseMove = (ev) => {
      const deltaX = ev.clientX - startX;
      const deltaY = ev.clientY - startY;
      setBlocks((prev) =>
        prev.map((b) =>
          b.id === block.id
            ? {
              ...b,
              width: Math.max(20, startWidth + deltaX),
              height: Math.max(20, startHeight + deltaY),
            }
            : b
        )
      );
    };

    document.addEventListener("mousemove", onMouseMove);
    document.addEventListener(
      "mouseup",
      () => document.removeEventListener("mousemove", onMouseMove),
      { once: true }
    );
  };

  const handleReset = () => setBlocks([]);

  const handleTrashDrop = (e) => {
    e.preventDefault();
    const id = e.dataTransfer.getData("blockId");
    setBlocks((prev) => prev.filter((b) => b.id !== id));
  };

  const handleDragStartGrid = (e, id) => {
    e.dataTransfer.setData("blockId", id);
  };

  const handleTextChange = (e, blockId) => {
    const text = e.target.value;
    setBlocks((prev) => prev.map((b) => (b.id === blockId ? { ...b, text } : b)));
  };


  const toggleEdit = (blockId, value) => {
    setBlocks((prev) =>
      prev.map((b) =>
        b.id === blockId ? { ...b, isEditing: value } : b
      )
    );
  };


  return (
    <div>
      <div style={toolbarStyle}>
        {blockTypes.map((type) => (
          <button
            key={type}
            style={buttonStyle}
            draggable
            onDragStart={(e) => handleDragStartToolbar(e, type)}
          >
            {type.replace(/([A-Z])/g, " $1").trim()}
          </button>
        ))}
      </div>

      <div
        ref={gridRef}
        style={gridStyle}
        onDrop={handleDropGrid}
        onDragOver={handleDragOverGrid}
      >
        {blocks.map((block) => (
          <div
            key={block.id}
            draggable
            onDragStart={(e) => handleDragStartGrid(e, block.id)}
            style={{
              ...getBlockStyle(block.type),
              left: block.x,
              top: block.y,
            }}
            onMouseDown={(e) => handleMouseDown(e, block)}
            onContextMenu={(e) => {
              e.preventDefault();
              setBlocks((prev) => prev.filter((b) => b.id !== block.id));
            }}
          >


            {block.type.startsWith("Arrow") ? (
              <div style={{ position: "relative" }}>
                {block.type === "ArrowDown" && (
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    fill="black"
                    viewBox="0 0 24 24"
                    width={block.width}
                    height={block.height}
                  >
                    <path
                      d="M12 2v18M5 14l7 7 7-7"
                      stroke="black"
                      strokeWidth={2}
                      fill="none"
                    />
                  </svg>
                )}
                {block.type === "ArrowRight" && (
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 100 100"
                    width={block.width}
                    height={block.height}
                  >
                    <g transform="scale(-1,1) translate(-100,0)">
                      <path d="M80 20 H40 V70" stroke="black" strokeWidth="3" fill="none" />
                      <polygon points="35,70 45,70 40,80" fill="black" />
                    </g>
                  </svg>
                )}

                {block.type === "ArrowLeft" && (
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 100 100"
                    width={block.width}
                    height={block.height}
                  >
                    <path d="M80 20 H40 V70" stroke="black" strokeWidth="3" fill="none" />
                    <polygon points="35,70 45,70 40,80" fill="black" />
                  </svg>
                )}





                {/* Resize handle */}
                <div
                  onMouseDown={(e) => handleResizeMouseDown(e, block)}
                  style={{
                    position: "absolute",
                    bottom: -6,
                    right: -6,
                    width: 14,
                    height: 14,
                    background: "rgba(255,0,0,0.7)",
                    borderRadius: "50%",
                    cursor: "nwse-resize",
                    opacity: 0,
                    transition: "opacity 0.2s",
                  }}
                  onMouseEnter={(e) => (e.currentTarget.style.opacity = 1)}
                  onMouseLeave={(e) => (e.currentTarget.style.opacity = 0)}
                ></div>

              </div>
            ) : block.isEditing ? (
              <input
                type="text"
                value={block.text}
                autoFocus
                onBlur={() => toggleEdit(block.id, false)}
                onChange={(e) => handleTextChange(e, block.id)}
                style={{
                  width: "100%",
                  border: "none",
                  borderRadius: 4,
                  padding: 5,
                  fontSize: 14,
                  textAlign: "center",
                }}
              />
            ) : (
              <div
                onDoubleClick={() => toggleEdit(block.id, true)}
                style={{ cursor: "text" }}
              >
                {block.text}
              </div>
            )}
          </div>
        ))}
      </div>

      <div
        ref={trashRef}
        style={trashStyle}
        onDragOver={(e) => e.preventDefault()}
        onDrop={handleTrashDrop}
      >
        🗑️
      </div>

      <button style={resetBtnStyle} onClick={handleReset}>
        Reset
      </button>
    </div>
  );
};

export default FlowchartBuilder;
